const testimonials = [
  {
    name: "周晓棠",
    role: "内容运营",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20woman%20reader%20with%20warm%20neutral%20studio%20background%2C%20soft%20light%2C%20editorial%20photography%2C%20high%20detail&width=300&height=300&seq=hei-avatar-a&orientation=squarish",
    quote:
      "以前看到一个热点，得刷好几个平台的碎片才能拼出大概。现在直接读时间线，五分钟就知道谁先说了什么，省下的时间能用来判断而不是找料。",
  },
  {
    name: "陈一鸣",
    role: "产品经理",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20man%20in%20his%20thirties%20with%20warm%20neutral%20studio%20background%2C%20soft%20light%2C%20editorial%20photography%2C%20high%20detail&width=300&height=300&seq=hei-avatar-b&orientation=squarish",
    quote:
      "最喜欢「各方视角」这一块。同一个事件，品牌方、当事用户和从业者放在一起看，很多原本觉得一边倒的事，其实没那么简单。",
  },
  {
    name: "林可",
    role: "自由撰稿人",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20woman%20journalist%20with%20warm%20neutral%20studio%20background%2C%20soft%20light%2C%20editorial%20photography%2C%20high%20detail&width=300&height=300&seq=hei-avatar-c&orientation=squarish",
    quote:
      "写稿前会先来这里对一遍时间线，节点里带出处这点特别实用，核对素材的效率高了很多，也少踩了转述带来的坑。",
  },
];

export default function Testimonials() {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
            读者反馈
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            他们这样用黑料热点
          </h2>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="h-11 w-11 overflow-hidden rounded-full bg-background-200">
                  <img
                    src={item.avatar}
                    alt={`${item.name}的头像`}
                    title={`${item.name} - 黑料热点读者`}
                    className="h-full w-full object-top object-cover"
                  />
                </span>
                <span>
                  <span className="block font-heading text-sm font-bold text-foreground-950">
                    {item.name}
                  </span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}